/**
 * Thinker theme - Free shipping progress (minimal)
 * - Shows block only when cart has items
 * - No product quantity logic
 * - Always shows full bar
 * - Minimal message only
 */

(() => {
  const SETTINGS = {
    message: "Parabéns, você ganhou frete grátis.",
  };

  let lastCartSignature = "";

  async function fetchCart() {
    const res = await fetch(`${Shopify?.routes?.root || "/"}cart.js`, {
      credentials: "same-origin",
    });
    if (!res.ok) throw new Error("Falha ao buscar /cart.js");
    return res.json();
  }

  function cartSignature(cart) {
    return (cart.items || [])
      .map((i) => `${i.variant_id}:${i.quantity}`)
      .sort()
      .join("|");
  }

  function computeCartTotalQty(cart) {
    const items = cart.items || [];
    let cartTotalQty = 0;

    for (const item of items) {
      cartTotalQty += Number(item.quantity) || 0;
    }

    return cartTotalQty;
  }

  function findDrawerDialog() {
    const drawer = document.querySelector("cart-drawer-component");
    const dialog = drawer?.querySelector("dialog");
    return dialog || null;
  }

  function ensurePromoBlock(dialog) {
    const content = dialog.querySelector(".cart-drawer__content") || dialog;
    if (!content) return null;

    let block = dialog.querySelector("[data-free-shipping-progress]");
    if (!block) {
      block = document.createElement("div");
      block.setAttribute("data-free-shipping-progress", "true");
      block.className = "free-shipping-progress";

      block.innerHTML = `
        <div class="free-shipping-progress__msg" data-free-shipping-msg></div>
        <div class="free-shipping-progress__barwrap" aria-hidden="true">
          <div class="free-shipping-progress__bar">
            <div class="free-shipping-progress__barfill"></div>
          </div>
        </div>
      `;

      content.prepend(block);
    }

    return block;
  }

  function updatePromoUI(dialog, cart) {
    const block = ensurePromoBlock(dialog);
    if (!block) return;

    const cartTotalQty = computeCartTotalQty(cart);

    // Só aparece se tiver algo no carrinho
    if (cartTotalQty <= 0) {
      block.style.display = "none";
      return;
    }

    block.style.display = "";

    const msgEl = block.querySelector("[data-free-shipping-msg]");
    if (msgEl) {
      msgEl.textContent = SETTINGS.message;
    }
  }

  function hookFetch() {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const res = await originalFetch(...args);

      try {
        const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
        const isCartEndpoint =
          url.includes("/cart/add") ||
          url.includes("/cart/change") ||
          url.includes("/cart/update") ||
          url.includes("/cart/clear");

        if (isCartEndpoint) {
          queueMicrotask(() => run().catch(() => {}));
        }
      } catch (_) {}

      return res;
    };
  }

  function injectCSS() {
    if (document.querySelector("#free-shipping-progress-style")) return;

    const s = document.createElement("style");
    s.id = "free-shipping-progress-style";
    s.textContent = `
      .free-shipping-progress{
        margin: 10px var(--drawer-padding, 16px) 8px;
        padding: 1px 0 12px;
      }

      .free-shipping-progress__msg{
        font-size: 14px;
        line-height: 1.4;
        opacity: 0.75;
        margin-bottom: 8px;
        text-align: left;
      }

      .free-shipping-progress__barwrap{
        position: relative;
      }

      .free-shipping-progress__bar{
        width: 100%;
        height: 4px;
        border-radius: 999px;
        background: rgba(var(--color-foreground-rgb, 0 0 0) / 0.10);
        overflow: hidden;
      }

      .free-shipping-progress__barfill{
        width: 100%;
        height: 100%;
        border-radius: 999px;
        background: rgba(var(--color-foreground-rgb, 0 0 0) / 0.8);
      }
    `;

    document.head.appendChild(s);
  }

  async function run() {
    const dialog = findDrawerDialog();
    if (!dialog) return;

    const cart = await fetchCart();
    const sig = cartSignature(cart);

    if (sig === lastCartSignature) {
      updatePromoUI(dialog, cart);
      return;
    }

    lastCartSignature = sig;
    updatePromoUI(dialog, cart);
  }

  function start() {
    injectCSS();
    hookFetch();

    document.addEventListener("DOMContentLoaded", () => run().catch(() => {}));
    document.addEventListener("cart:refresh", () => run().catch(() => {}));
    document.addEventListener("cart:update", () => run().catch(() => {}));

    document.addEventListener("click", (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (t.closest("cart-drawer-component")) {
        queueMicrotask(() => run().catch(() => {}));
      }
    });

    setInterval(() => {
      if (document.querySelector("cart-drawer-component dialog[open]")) {
        run().catch(() => {});
      }
    }, 1500);
  }

  start();
})();